import IntegrationListItem from 'components/IntegrationList/IntegrationListItem'
import { useIntegrationList } from 'api/chat-api-integration'
import { CircularProgress } from '@mui/joy'
import { useQueryClient } from 'react-query'
import { useContext, useEffect } from 'react'
import { Box } from '@mui/material'
import { AuthContext } from 'context/Auth'

type Props = {}

const IntegrationList = (props: Props) => {
    const queryClient = useQueryClient()

    const { user } = useContext(AuthContext)

    if (!user?.access) {
        throw new Error('User has no access and cannot fetch messages.')
    }

    const workspaceId = user?.access?.workspaceId
    const userId = user?.access?.internalUserId

    const { data: integrationList, isLoading } = useIntegrationList({
        workspaceId: workspaceId,
        userId: userId,
        limit: 25,
        page: 1,
    })

    if (isLoading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: 40,
                }}
            >
                <CircularProgress color="primary" size="lg" />
            </Box>
        )
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
            }}
        >
            {integrationList?.map((item: any, i: any) => (
                <IntegrationListItem key={i} item={item} />
            ))}
        </Box>
    )
}

export default IntegrationList
